import { ConsoleDecorator } from './ConsoleDecorator.js';
/**
 * Console Logger
 *
 * Prints logs with a nice header.
 * @example
 * const console_logger = new ConsoleLogger("My Name");
 * console_logger.log("My Message");
 */
export class ConsoleLogger {
    constructor(name) {
        this.name = name;
        this.log = this._create_console_method('log');
        this.debug = this._create_console_method('debug');
        this.info = this._create_console_method('info');
        this.warn = this._create_console_method('warn');
        this.error = this._create_console_method('error');
    }
    _create_console_method(type) {
        const style = ConsoleDecorator.get_style(type);
        return Function.prototype.bind.apply(console[type], [console, `%c${this.name}`, ...style]);
    }
}
//# sourceMappingURL=ConsoleLogger.js.map